import { useMemo } from 'react'

import { Skeleton } from 'antd'

import { CustomFieldGroup } from './components/CustomFieldGroup'
import { CustomFieldSingle } from './components/CustomFieldSingle'
import { FillingSteps } from './components/FillingSteps'
import { PanelHeader } from './components/PanelHeader'
import { buildFieldsById, isFieldVisible } from './helpers/requiredRule'
import { useCustomFields } from './hooks/useCustomFields'

import './styles.less'

export function CustomFields(props) {
  const {
    formValues,
    visibleGroups,
    customFields,
    isLoading,
    onChangeValue,
    actionName,
    setGroupVisible,
    setGroupHidden,
    visibleFields,
    isReadOnly,
    isPreview
  } = useCustomFields(props)

  const { errors } = props

  const fieldsById = useMemo(
    () => (customFields ? buildFieldsById(Array.from(customFields.values()).flatMap(({ fields }) => fields)) : {}),
    [customFields]
  )

  // Visibilidade condicional: um campo com requiredWhen só aparece quando a
  // condição é atendida (resolvendo a origem da mesma instância do grupo).
  const isVisible = (field) => isFieldVisible(field, formValues, fieldsById)

  function hasFieldErrors(fields) {
    return fields.some(({ internalFieldName }) => internalFieldName in errors)
  }

  const renderPanelHeader = (groupName, fields) => (
    <PanelHeader groupName={groupName} fields={fields} formValues={formValues} fieldsById={fieldsById} />
  )

  if (isLoading) {
    return (
      <div className="CustomFieldsComponent__skeleton">
        <Skeleton active />
      </div>
    )
  }

  if (!customFields) return null

  return (
    <div className="CustomFieldsComponent">
      <hr />
      <FillingSteps actionName={actionName} fieldGroups={visibleFields} formValues={formValues} />

      {Object.keys(visibleGroups).length > 0 &&
        Array.from(customFields.entries()).map(([fieldName, { isGroup, isGroupUnderGroup, groupType, fields }]) => {
          if (!isGroup) {
            const field = fields[0]

            // Esconde o campo enquanto a condição do requiredWhen não é atendida.
            if (!isVisible(field)) {
              return null
            }

            return (
              <CustomFieldSingle
                key={fieldName}
                field={field}
                fields={fields}
                onChangeValue={onChangeValue}
                errors={errors}
                value={formValues[field.internalFieldName]}
                formValues={formValues}
                fieldsById={fieldsById}
                isReadOnly={isReadOnly}
                isPreview={isPreview}
              />
            )
          }

          // Dentro de grupos, oculta apenas os campos cuja condição não é atendida.
          const visibleGroupFields = fields.filter(isVisible)

          if (visibleGroupFields.length === 0) {
            return null
          }

          return (
            <CustomFieldGroup
              key={fieldName}
              fieldName={fieldName}
              fields={visibleGroupFields}
              hasFieldErrors={hasFieldErrors}
              renderPanelHeader={renderPanelHeader}
              formValues={formValues}
              fieldsById={fieldsById}
              onChangeValue={onChangeValue}
              errors={errors}
              isReadOnly={isReadOnly}
              isPreview={isPreview}
              visibleGroups={visibleGroups}
              groupType={groupType}
              setGroupVisible={setGroupVisible}
              setGroupHidden={setGroupHidden}
              isGroupUnderGroup={isGroupUnderGroup}
            />
          )
        })}
    </div>
  )
}
